import gtocImage from './GTOClogo.jpg'
const GtocLogo = () => {
  return gtocImage
}

export default GtocLogo
